'use strict';

const SoaCollection = require('bunsen/collections/SoaCollection');

const TrendingItem = require('bunsen/models/identity/TrendingItem');
const endpoints = require('dibs-endpoints');

const TrendingItems = SoaCollection.extend({
    url: endpoints.trending(),
    model : TrendingItem,

    TYPE_CATEGORY: 'CATEGORY',
    TYPE_ATTRIBUTE: 'ATTRIBUTE',
    TYPE_ITEM: 'ITEM'
});

module.exports = TrendingItems;



// WEBPACK FOOTER //
// ./~/bunsen/collections/identity/TrendingItems.es.js